import { GET_LOADS } from "../actions/types";
// import { loadTest } from "../testData/loadTest";

const initialState = {
  loads: {}, // to test loadTest(),
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_LOADS:
      return {
        ...state,
        loads: action.payload,
      };
    default:
      return state;
  }
}
